import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule} from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CanAccessDirective } from '../_directives/can-access.directive';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../_services/common.service';
import { EllipsisPipe } from '../_pipes/ellipsis.pipe';
import { FilterByPipe } from '../_pipes/filter-by.pipe';
import { NameInitialsPipe } from '../_pipes/name-initials.pipe';
import { InPageErrorBlockModule } from '../in-page-error-block/in-page-error-block.module';
import { ModalsModule } from '../modals/modals.module';
import { NgxVcardModule } from 'ngx-vcard';
import { CanAccessMoreDirective } from '../_directives/can-access-more.directive';
import { PhoneMaskDirective } from '../_directives/phone-mask.directive';
import { FeinMaskDirective } from '../_directives/fein-mask.directive';
import { ZipCodeMaskDirective } from '../_directives/zip-code-mask.directive';
import { DragNDropDirective } from '../_directives/drag-ndrop.directive';
import { DownloadVCardDirective } from '../_directives/download-vcard.directive';
import { CustomInputTypeDirective } from '../_directives/custom-input-type.directive';
import { FormatInputTypePipe } from '../_pipes/format-input-type.pipe';
import { AuthenticationComponent } from '../login/authentication/authentication.component';

@NgModule({
  declarations: [
    HeaderComponent,
    CanAccessDirective,
    CanAccessMoreDirective,
    EllipsisPipe,
    FilterByPipe,
    NameInitialsPipe, 
    FormatInputTypePipe,
    PhoneMaskDirective,
    FeinMaskDirective,
    ZipCodeMaskDirective,
    DragNDropDirective,
    DownloadVCardDirective,
    CustomInputTypeDirective,
    AuthenticationComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    InPageErrorBlockModule,
    ModalsModule,
    NgxVcardModule
  ],
  exports: [
    HeaderComponent,
    CanAccessDirective,
    CanAccessMoreDirective,
    EllipsisPipe,
    FilterByPipe,
    NameInitialsPipe,
    FormatInputTypePipe,
    InPageErrorBlockModule,
    ModalsModule, 
    PhoneMaskDirective,
    FeinMaskDirective,
    ZipCodeMaskDirective,
    DragNDropDirective,
    DownloadVCardDirective,
    CustomInputTypeDirective,
    AuthenticationComponent
  ],
  providers: [CommonService, FormatInputTypePipe]
})
export class HeaderModule { }
